import { render, staticRenderFns } from "./CompleteRegistration.vue?vue&type=template&id=82a1ed8e&scoped=true"
import script from "./CompleteRegistration.vue?vue&type=script&lang=js"
export * from "./CompleteRegistration.vue?vue&type=script&lang=js"
import style0 from "./CompleteRegistration.vue?vue&type=style&index=0&id=82a1ed8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a1ed8e",
  null
  
)

export default component.exports